import { FC } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { Modal, Typography, PLATFORM_THEME_COLORS } from '@thinknet-gmbh/platform-common-ui';

import { ISubscribeInfo } from 'src/components/software-plans-modal/software-plans-modal.interfaces';

import { PaymentCardForm } from './payment-card-form';

interface IProps {
  title: string;
  subtitle: string;
  isOpened: boolean;
  onClose: () => void;
  subscribeInfo: ISubscribeInfo;
}

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISH_KEY);

const PaymentModal: FC<IProps> = ({ title, subtitle, isOpened, subscribeInfo, onClose }) => (
  <Modal
    title={title}
    isOpened={isOpened}
    onClose={onClose}
    smallerPadding
    closable={false}
    keyboard={false}
  >
    <Elements stripe={stripePromise}>
      <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>{subtitle}</Typography>
      <PaymentCardForm onClose={onClose} subscribeInfo={subscribeInfo} />
    </Elements>
  </Modal>
);

export default PaymentModal;
